export default "/images/volume-2.svg?374d26cdd53cd031ee624ec0c1ac1640";